import Warning from '@mui/icons-material/Warning';
import { useMemo } from 'react';

import { useCommandBarAllValues } from '#components/command-bar/command-bar-context.js';
import { useCommandBarStore } from '#components/command-bar/command-bar-store.js';
import { MODULE_SEARCH_PREFIX, MODULE_SEARCH_PROVIDER_ID } from './module-search-types.js';

export function ModuleSearchEmptyMessage() {
	const search = useCommandBarStore((s) => s.search);
	const providers = useCommandBarAllValues('providers');

	const shouldShow = search.startsWith(MODULE_SEARCH_PREFIX);
	const isProviderAvailable = useMemo(() => providers.some((p) => p.id === MODULE_SEARCH_PROVIDER_ID), [providers]);

	if (!shouldShow) {
		return null;
	}

	if (!isProviderAvailable) {
		return (
			<span className='flex items-center gap-2 text-amber-a12'>
				<Warning className='text-amber-10' />
				Module search is not available on this page
			</span>
		);
	}

	return 'Enter a reference designator to search modules';
}
